<template lang="pug">
  v-card
    v-img(:src ="imageSrc")
    v-card-title
      strong {{epackage.packageName}}
      v-flex(xs12) ${{epackage.cost}}
    v-layout(row wrap)
      v-flex(xs12)
        v-layout(row)
          span.pl-4 Includes: 
          v-flex()
            v-btn( icon @click="showDescription = !showDescription" color="primary" small dark)
              v-icon(v-if="!showDescription") expand_more
              v-icon(v-else) expand_less
      v-flex(v-if="showDescription" )
        v-card.py-2(color="blue-grey lighten-5" flat)
          div.body-2 
            ul
              li.py-1(v-for="item in epackage.contents" style="list-style-type: none") {{item}}
    v-layout(row)
      v-flex(xs6)
        add-to-cart-btn(:item="itemWithAmount" @inCart="setInCart" itemType='package')
      v-flex.text-xs-center(xs6)
        number-input(@increment="increment()" @decrement="decrement()" :val="amount"  :disabled="inCart")
      
      
</template>
<script>
import AddToCartBtn from '@/components/AddToCartBtn'
import NumberInput from '@/components/NumberInput'
export default {
  props:['epackage'],
  data:()=>({
    amount:1,
    showDescription: false,
    inCart: false
  }),
  components:{AddToCartBtn, NumberInput},
  computed:{
    imageSrc(){return this.$store.state.baseImageURL + this.epackage.imageURL+"?alt=media"},
    itemWithAmount(){
      let obj = this.epackage
      obj.amount = this.amount
      obj = JSON.parse(JSON.stringify(obj))
      return obj
    }
  },
  methods:{
    increment(){
      this.amount+=1
    },
    decrement(){
      this.amount-=1
    },
    setInCart(res){
      if (res.item === this.itemWithAmount){
        this.inCart = res.status
        if (res.amount){
          this.amount = res.amount
        }

      }
    }
  }
}
</script>



